import React from "react";
import {
  PlusCircle,
  PauseCircle,
  Plus,
  Clock,
  PlayCircle
} from "feather-icons-react/build/IconComponents";
import './Menus.css';
import MenuCard from "../../components/menucard/menucard";
import AddMenu from "../../../core/modals/menus/addmenu";
import { base_api_url } from "../../../environment.jsx";
import SessionControl from "../../components/SessionControl/sessioncontrol";
import CheckRestauSelected from "../../components/SessionControl/checkrestauselected";
import { all_routes } from "../../../Router/all_routes";
import { useEffect, useState } from 'react';
import axios from "axios";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

const Menus = () => {
  const [menus, setmenus] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedMenu, setSelectedMenu] = useState(null);
  const [showAddMenuModal, setShowAddMenuModal] = useState(false);
  const [priseCmd, setPriseCmd] = useState('');
  // Initialize blocked state synchronously from localStorage
  const savedEndTime = localStorage.getItem('orderBlockEndTime');
  const isStillBlocked = savedEndTime && parseInt(savedEndTime, 10) > Date.now();

  const [blockingOrders, setBlockingOrders] = useState(isStillBlocked);
  const [countdown, setCountdown] = useState(null);
  const countdownRef = React.useRef(null);

  const MySwal = withReactContent(Swal);

  // Countdown timer logic
  const startCountdown = (endTime) => {
    if (countdownRef.current) clearInterval(countdownRef.current);
    const tick = () => {
      const remaining = Math.max(0, Math.floor((endTime - Date.now()) / 1000));
      if (remaining <= 0) {
        setBlockingOrders(false);
        setCountdown(null);
        clearInterval(countdownRef.current);
        localStorage.removeItem('orderBlockEndTime');
      } else {
        const m = String(Math.floor(remaining / 60)).padStart(2, '0');
        const s = String(remaining % 60).padStart(2, '0');
        setCountdown(`${m}:${s}`);
      }
    };
    tick(); // immediately show
    countdownRef.current = setInterval(tick, 1000);
  };

  // Restore countdown from localStorage on mount
  React.useEffect(() => {
    const saved = localStorage.getItem('orderBlockEndTime');
    if (saved) {
      const endTime = parseInt(saved, 10);
      if (endTime > Date.now()) {
        startCountdown(endTime);
      } else {
        // Expired while away
        localStorage.removeItem('orderBlockEndTime');
        setBlockingOrders(false);
      }
    }
    return () => { if (countdownRef.current) clearInterval(countdownRef.current); };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Charger les menus depuis l'API au chargement du composant
  useEffect(() => {
    fetchMenus();
  }, []);

  const fetchMenus = async () => {
    setLoading(true);
    const token = JSON.parse(localStorage.getItem("user"))?.access_token;
    const ideresto = JSON.parse(localStorage.getItem("user"))?.restoId;
    let url = `${base_api_url}api/listMenu/${ideresto}/0`;
    try {
      const response = await axios.get(url, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setmenus(response.data.menu);
      console.log("la reponse:", response.data)
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  // Function to refresh menu data after successful update
  const handleRefreshMenus = () => {
    console.log("Refreshing menus data...");
    fetchMenus(); // Re-fetch the menus data
  };

  // Function to block orders
  const handleBlockOrders = async () => {
    if (!priseCmd || priseCmd <= 0) {
      MySwal.fire({
        icon: 'error',
        text: "Veuillez saisir un nombre de minutes valide",
        toast: true,
        position: "bottom-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        customClass: {
          popup: "pixel-toast",
        },
      });
      return;
    }

    setBlockingOrders(true);
    const token = JSON.parse(localStorage.getItem("user"))?.access_token;

    try {
      const restaurantId = JSON.parse(localStorage.getItem("user"))?.restoId;

      // Calculate future timestamp based on minutes
      const now = new Date();
      const futureTime = new Date(now.getTime() + (parseInt(priseCmd) * 60 * 1000));
      const priseCommandeTimestamp = futureTime.toISOString();

      // Prepare payload
      const paylod = {
        prise_cmd: priseCommandeTimestamp
      }
      console.log("Payload envoyé:", paylod);
      const response = await axios.put(`${base_api_url}api/restaurant/${restaurantId}`,
        paylod,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      console.log("Réponse du serveur:", response.data);
      // Success notification
      MySwal.fire({
        icon: 'success',
        text: `Commandes bloquées pour ${priseCmd} minutes avec succès`,
        toast: true,
        position: "bottom-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        customClass: { popup: "pixel-toast" },
      });
      startCountdown(futureTime.getTime());
      localStorage.setItem('orderBlockEndTime', String(futureTime.getTime()));
      setPriseCmd('');

    } catch (error) {
      console.error("Erreur lors du blocage des commandes:", error);
      MySwal.fire({
        icon: 'error',
        text: "Erreur lors du blocage des commandes. Veuillez réessayer.",
        toast: true,
        position: "bottom-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        customClass: {
          popup: "pixel-toast",
        },
      });
      // Only reset on error — on success, blockingOrders stays true until countdown ends or user unblocks
      setBlockingOrders(false);
    }
  };

  const handleUnblockOrders = async () => {
    const token = JSON.parse(localStorage.getItem("user"))?.access_token;

    try {
      const restaurantId = JSON.parse(localStorage.getItem("user"))?.restoId;

      // Réduire de 5 minutes par rapport au temps actuel
      const now = new Date();
      const pastTime = new Date(now.getTime() - (5 * 60 * 1000));
      const priseCommandeTimestamp = pastTime.toISOString();

      const payload = { prise_cmd: priseCommandeTimestamp };

      await axios.put(`${base_api_url}api/restaurant/${restaurantId}`,
        payload,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      MySwal.fire({
        icon: 'success',
        text: 'Les commandes sont maintenant disponibles',
        toast: true,
        position: "bottom-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        customClass: { popup: "pixel-toast" },
      });
      // Reset blocked state on success
      setBlockingOrders(false);
      setCountdown(null);
      if (countdownRef.current) clearInterval(countdownRef.current);
      localStorage.removeItem('orderBlockEndTime');

    } catch (error) {
      console.error("Erreur lors du déblocage des commandes:", error);
      MySwal.fire({
        icon: 'error',
        text: "Erreur lors du déblocage des commandes. Veuillez réessayer.",
        toast: true,
        position: "bottom-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        customClass: { popup: "pixel-toast" },
      });
      // Keep the blocked state on error
    }
  };

  const route = all_routes;
  return (
    <div className="page-wrapper menus-page">
      <SessionControl
        storageKey="user"
        propsup="email"
        redirectTo={route.signin}
      />
      <CheckRestauSelected
        storageKey="user"
        redirectTo={route.Restaurants}
      />

      {/* EN-TÊTE PREMIUM */}
      <div className="menus-header">
        <div className="header-left">
          <h2>Menus</h2>
          <p>Composez et gérez les menus de votre restaurant</p>
        </div>
        <button
          className="btn-add-menu"
          onClick={() => {
            setSelectedMenu(null);
            setShowAddMenuModal(true);
          }}
        >
          <Plus size={18} className="d-md-none" />
          <span className="d-none d-md-inline">Ajouter un menu</span>
        </button>
      </div>

        {/* BLOCAGE TEMPORAIRE DES COMMANDES MODERNISÉ */}
        <div className={`block-orders-card ${blockingOrders ? 'blocked' : ''}`}>
          <div className="block-orders-left">
            <div className="icon-pause">
              <PauseCircle size={22} />
            </div>
            <div className="block-text">
              <h4>
                Blocage temporaire des commandes
                {blockingOrders && <span className="badge-blocked">Commandes bloquées</span>}
              </h4>
              <p>Suspendre les commandes pendant un temps défini (coup de feu, rupture, pause technique)</p>
            </div>
          </div>
          <div className="block-controls">
            {blockingOrders ? (
              // BLOCKED STATE
              <>
                <div className="countdown-display">
                  <Clock size={16} />
                  <span>{countdown || '...'}</span>
                </div>
                <button
                  className="btn-unblock"
                  onClick={handleUnblockOrders}
                >
                  <PlayCircle size={16} style={{ marginRight: '6px' }} />
                  D&eacute;bloquer
                </button>
              </>
            ) : (
              // TIMER CONTROLS
              <>
                <div className="time-control">
                  <button
                    className="btn-time"
                    onClick={() => setPriseCmd((p) => Math.max(0, (Number(p) || 15) - 5))}
                  >
                    -
                  </button>
                  <span className="time-display">
                    {priseCmd || '15'} min
                  </span>
                  <button
                    className="btn-time"
                    onClick={() => setPriseCmd((p) => (Number(p) || 15) + 5)}
                  >
                    +
                  </button>
                </div>
                <button
                  className="btn-block"
                  onClick={handleBlockOrders}
                >
                  <PauseCircle size={16} style={{ marginRight: '8px' }} />
                  Bloquer
                </button>
              </>
            )}
          </div>
        </div>

        {/* GRILLE DES MENUS RE-STYLISÉE */}
        <div className="mb-2">
          {loading ? (
            <div className="text-center py-5">
              <div className="spinner-border text-primary" role="status">
                <span className="sr-only">Chargement...</span>
              </div>
            </div>
          ) : menus && menus.length > 0 ? (
            <div className="menus-grid">
              {[...menus]
                .sort((a, b) => a.id_menu - b.id_menu)
                .map((menu, index) => (
                  <MenuCard
                    key={menu.id_menu || index}
                    title={menu.nom}
                    detail={menu.detail}
                    description={menu.description}
                    isActive={menu.disponible}
                    menuId={menu.id_menu}
                    menu={menus}
                    nbArticles={menu.nb_articles || 0}
                    onRefresh={handleRefreshMenus}
                  />
                ))}
            </div>
          ) : (
            <div className="menus-empty text-center py-5">
              <PlusCircle size={64} color="#e2e8f0" style={{ marginBottom: '24px' }} />
              <h3>Aucun menu configuré</h3>
              <p>Commencez par ajouter votre premier menu pour recevoir des commandes.</p>
              <button
                className="btn-add-menu"
                style={{ margin: '0 auto' }}
                onClick={() => {
                  setSelectedMenu(null);
                  setShowAddMenuModal(true);
                }}
              >
                <PlusCircle size={18} className="d-md-none" style={{ marginRight: '8px' }} />
                <span className="d-none d-md-inline">Créer mon premier menu</span>
              </button>
            </div>
          )}
        </div>

        {showAddMenuModal && (
          <AddMenu
            show={showAddMenuModal}
            onClose={() => setShowAddMenuModal(false)}
            onFormSubmit={() => {
              setShowAddMenuModal(false);
              setSelectedMenu(null);
              handleRefreshMenus();
            }}
            menuData={selectedMenu}
          />
        )}
        </div>
    );
};

export default Menus;
